export default __webpack_public_path__ + "static/media/1-3-x@2x.ec7bd027.png";